module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C3606"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("LIST ")]), _vm._v("OF TABLES ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5863"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DoD Levels of Information Systems Interoperability (LISI) Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Business Value: Holistic vs. Project Approach ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Product Segment – Sample Forms ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responsible Departments of (Fictitious) Enterprise (AS-IS) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responsible Production Management Systems of (Fictitious) Enterprise (AS-IS) ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Example of the Equipment Hierarchy of a Company ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of a Process Segment ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stakeholders Feedback ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measurement of Identified Options (or Projects) against Two (2) Factors: Achievability and Benefit Contribution ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examples of Production Indicators ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOR Level 1 Benchmark Metrics [Note to Scott: This should probably be 7-4 as I couldn’t find Table 7-4 prior to this one in ")]), _c('span', {
    attrs: {
      "href": "#/html/19_Chapter#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter ")]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7, which means it needs to be changed in the chapter, too. Thx. Susan] ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_157",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("8-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.02-2001 Object Model to B2MML Schema Mapping ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a979ba0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_List_of.vue
// module id = 72
// module chunks = 0